<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Stats and Option Selector-->
<div class="lock-to-top" style="background-color: #ffffff; margin-bottom: 25px; margin-top: 0">
	<div class="date-body">
		<div class="selector-body">
			<div class="selector-item" style="display: flex">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						name="StartDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						name="EndDate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<div class="total-body">
		<div class="StatsGrid" style="margin-left: 20px; margin-right: 20px; padding-bottom: 5px">
			<div>
				<label>Total Merits and Demerits:</label>
				<label class="statcount">{{ MDTotalCount }}</label>
			</div>

			<div>
				<label>Merits:</label>
				<label class="statcount">{{ MeritCount }}</label>
				<label class="statpct">({{ MeritPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Demerits:</label>
				<label class="statcount">{{ DemeritCount }}</label>
				<label class="statpct">({{ DemeritPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Point Difference:</label>
				<label class="statcount">{{ TotalPointCount }}</label>
				<label class="statpct">(out of {{ AllPoints }} total)</label>
			</div>

			<div>
				<label>Merit Points:</label>
				<label class="statcount">{{ MeritPoints }}</label>
				<label class="statpct">({{ MeritPointPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Demerit Points:</label>
				<label class="statcount">{{ DemeritPoints }}</label>
				<label class="statpct">({{ DemeritPointPCT | number : "1.0-2" }}%)</label>
			</div>
		</div>
	</div>
</div>

<!--Table-->
<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 0px"
							(click)="onRefresh()"
						>
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onAddMerit()"
						>
							Add Merit
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onEditMerit()"
						>
							Edit Merit
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onDeleteMerit()"
						>
							Delete Merit
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintMerit()"
						>
							Print Merit
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstMeritPerson"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedMeritPerson"
						dataKey="MeritPersonID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--MeritDT-->
								<th>
									<p-columnFilter type="text" field="MeritDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--MeritDesc-->
								<th>
									<p-columnFilter type="text" field="MeritDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--MeritValue-->
								<th>
									<p-columnFilter type="text" field="MeritValue" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--IsDemeritDesc-->
								<th>
									<p-columnFilter id="IsDemeritDesc" field="IsDemeritDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterIsDemeritDesc
												[ngModel]="value"
												[options]="lstIsDemeritDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Comment-->
								<th>
									<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ScanStation-->
								<th>
									<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="MeritDT">Date/Time<p-sortIcon field="MeritDT"></p-sortIcon></th>
								<th pSortableColumn="MeritDesc">Description<p-sortIcon field="MeritDesc"></p-sortIcon></th>
								<th pSortableColumn="MeritValue">Value<p-sortIcon field="MeritValue"></p-sortIcon></th>
								<th pSortableColumn="IsDemeritDesc">Type<p-sortIcon field="IsDemeritDesc"></p-sortIcon></th>
								<th pSortableColumn="Comment">Comments<p-sortIcon field="Comment"></p-sortIcon></th>
								<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-MeritPerson>
							<tr [pSelectableRow]="MeritPerson" (dblclick)="onRowDblClick(MeritPerson)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ MeritPerson[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div *ngIf="isProcessing" class="TopMargin">
					<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
